// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseUnionModuleModuleLecturerResponseData } from './genericApiResponseUnionModuleModuleLecturerResponseData';
import type { GenericApiResponseUnionModuleModuleLecturerResponseMessage } from './genericApiResponseUnionModuleModuleLecturerResponseMessage';
import type { GenericApiResponseUnionModuleModuleLecturerResponsePagination } from './genericApiResponseUnionModuleModuleLecturerResponsePagination';
import type { GenericApiResponseUnionModuleModuleLecturerResponseError } from './genericApiResponseUnionModuleModuleLecturerResponseError';

export interface GenericApiResponseUnionModuleModuleLecturerResponse {
  data?: GenericApiResponseUnionModuleModuleLecturerResponseData;
  message?: GenericApiResponseUnionModuleModuleLecturerResponseMessage;
  pagination?: GenericApiResponseUnionModuleModuleLecturerResponsePagination;
  error?: GenericApiResponseUnionModuleModuleLecturerResponseError;
  statusCode?: number;
}
